/**
 * Who sells Scio — the details the law requires on the site (Elektroninės
 * komercijos įstatymo 5 str.). The ONE place they live: the contacts page, the
 * terms and the privacy policy all read them from here, so a change of address
 * is one edit and the three pages cannot disagree.
 *
 * TODO(owner): fill in the real values. Until then every value below starts
 * with "TODO", the pages show it as a bracketed placeholder, and
 * `rake release:check` reports it — blocking in production, a warning
 * anywhere else. Ruby reads THIS FILE too (`SellerDetails`, app/services/
 * seller_details.rb) — for that check and for the purchase confirmation mail —
 * so keep each value a plain double-quoted string on its own `key: "value",` line.
 *
 * `vatCode` may be set to "" if the seller is not a VAT payer — it is then left
 * off the pages rather than printed empty. Every other field is required.
 */
export const SELLER = {
  name: "TODO: vardas pavardė",
  ivCertificate: "TODO: pažymos numeris",
  vatCode: "TODO: kodas",
  address: "TODO: adresas",
  email: "TODO: el. pašto adresas",
} as const;

export type SellerField = keyof typeof SELLER;

/** Lithuanian labels, in the order the contacts page lists them. */
export const SELLER_LABELS: Record<SellerField, string> = {
  name: "Vardas, pavardė",
  ivCertificate: "Individualios veiklos pažymos Nr.",
  vatCode: "PVM mokėtojo kodas",
  address: "Adresas",
  email: "El. paštas",
};

export const SELLER_FIELDS = Object.keys(SELLER_LABELS) as SellerField[];

const PLACEHOLDER = /^TODO:?\s*/;

/** Whether a value is still the owner's TODO rather than a real detail. */
export function isSellerPlaceholder(value: string): boolean {
  return PLACEHOLDER.test(value.trim());
}

/**
 * A value as a page prints it. A placeholder reads the way the legal drafts
 * already mark unknown facts — „[adresas]" — rather than leaking „TODO".
 */
export function sellerValue(field: SellerField): string {
  const value: string = SELLER[field];
  return isSellerPlaceholder(value) ? `[${value.trim().replace(PLACEHOLDER, "")}]` : value;
}

/** The fields worth printing: everything except a VAT code left empty. */
export function sellerFieldsShown(): SellerField[] {
  return SELLER_FIELDS.filter((field) => field !== "vatCode" || SELLER.vatCode.trim() !== "");
}
